import { useGetAccountSummary } from './useGetAccountSummary';
import { useGetCreditDetails } from './useGetCreditDetails';
import { useGetDailyCreditUsage } from './useGetDailyCreditUsage';
import { useGetDeployementDetails } from './useGetDeployementDetails';
import { useGetDeploymentSummary } from './useGetDeploymentSummary';

export function useGetCreditDeploymentSummaryDetails(selectedProductCustomerId, fetchCreditDeploymentSummaryDetails) {
    const deploymentDetailsQuery = useGetDeployementDetails(
        selectedProductCustomerId,
        fetchCreditDeploymentSummaryDetails,
    );
    const {
        isLoading: isLoadingCreditDetails,
        isFetched: isFetchedCreditDetails,
        isFetching: isFetchingCreditDetails,
    } = useGetCreditDetails(
        {
            selectedProductCustomerId,
            protocol: deploymentDetailsQuery?.data?.result?.protocol,
            endpoint: deploymentDetailsQuery?.data?.result?.endpoint,
        },
        deploymentDetailsQuery.isFetched && deploymentDetailsQuery?.data?.success,
    );
    const {
        isLoading: isLoadingAccountSummary,
        isFetched: isFetchedAccountSummary,
        isFetching: isFetchingAccountSummary,
    } = useGetAccountSummary(
        {
            selectedProductCustomerId,
            protocol: deploymentDetailsQuery?.data?.result?.protocol,
            endpoint: deploymentDetailsQuery?.data?.result?.endpoint,
        },
        deploymentDetailsQuery.isFetched && deploymentDetailsQuery?.data?.success,
    );
    const {
        isLoading: isLoadingDailyCreditUsage,
        isFetched: isFetchedDailyCreditUsage,
        isFetching: isFetchingDailyCreditUsage,
    } = useGetDailyCreditUsage(
        {
            selectedProductCustomerId,
            protocol: deploymentDetailsQuery?.data?.result?.protocol,
            endpoint: deploymentDetailsQuery?.data?.result?.endpoint,
        },
        deploymentDetailsQuery.isFetched && deploymentDetailsQuery?.data?.success,
    );
    const {
        isLoading: isLoadingDeploymentSummary,
        isFetched: isFetchedDeploymentSummary,
        isFetching: isFetchingDeploymentSummary,
    } = useGetDeploymentSummary(
        {
            selectedProductCustomerId,
            protocol: deploymentDetailsQuery?.data?.result?.protocol,
            endpoint: deploymentDetailsQuery?.data?.result?.endpoint,
        },
        deploymentDetailsQuery.isFetched && deploymentDetailsQuery?.data?.success,
    );

    return {
        ...deploymentDetailsQuery,
        isLoading:
            deploymentDetailsQuery.isLoading ||
            isLoadingCreditDetails ||
            isLoadingAccountSummary ||
            isLoadingDeploymentSummary ||
            isLoadingDailyCreditUsage,
        isFetching:
            deploymentDetailsQuery.isFetching ||
            isFetchingCreditDetails ||
            isFetchingAccountSummary ||
            isFetchingDeploymentSummary ||
            isFetchingDailyCreditUsage,
        isFetched:
            deploymentDetailsQuery.isFetched &&
            isFetchedCreditDetails &&
            isFetchedAccountSummary &&
            isFetchedDeploymentSummary &&
            isFetchedDailyCreditUsage,
    };
}
